function ProductDetailPageHandler(product = '', event = '', data = {}) {
    const { metaData = {}, hotel = {}, searchQuery = {}, groupOptions = false, ipr = false, panFilter = false, mb = [],
        srn = '', mealType = '', tafcs = {}, ss = '' } = data,
        { uid = '', sn = '' } = hotel,
        { searchId = '', searchCriteria = {} } = searchQuery,
        { cityName = '' } = searchCriteria,
        [mealBasis = ''] = mb,
        { TAF = {} } = tafcs,
        { SGP = 0, SNP = 0, SAC = 0 } = TAF,
        { userId } = metaData;
    const view = groupOptions ? 'Grouped View' : 'Un-Grouped View';

    let finalData = {
        Identity: userId, product: product, searchId: searchId, unicaId: uid, location: cityName
    }

    switch (event) {
        case 'PageView':
            finalData = { ...finalData, supplier: sn }
            break;
        case 'SwitchView':
            finalData = { ...finalData, view }
            break;
        case 'RateFilter':
            finalData = { ...finalData, supplier: sn, panRequired: !panFilter, mealBasis }
            break;
        case 'MoreOptions':
            finalData = { ...finalData, supplier: sn, roomType: srn, mealBasis: mealType }
            break;
        case 'CancellationPolicy':
            finalData = { ...finalData, supplier: sn, roomType: srn, mealBasis: mealType }
            break;
        case 'RoomFacilities':
            finalData = { ...finalData, supplier: sn, roomType: srn, mealBasis: mealType }
            break;
        case 'MaximumCapacity':
            finalData = { ...finalData, supplier: sn, roomType: srn, mealBasis: mealType }
            break;
        case 'RoomImages':
            finalData = { ...finalData, supplier: sn, roomType: srn }
            break;
        case 'BookNow':
            finalData = { ...finalData, supplier: ss, gross: SGP, net: SNP, commission: SAC, panRequired: ipr }
            break;
        case "reviewLink": 
            finalData = { ...finalData, supplier: sn } 
            break;
        case "user_reviewLink": 
            finalData = { ...finalData, supplier: sn } 
            break;
           
    }

    return finalData;
}

module.exports = { ProductDetailPageHandler }